export default "__VITE_ASSET__BiOOt2KW__"